import lodash from 'lodash';
import React from 'react';
import {action} from 'mobx';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCaretRight} from '@fortawesome/free-solid-svg-icons';
import {observer, PropTypes as MobxPropTypes} from 'mobx-react';

import mainConfig from '../../../../../config/main';
import {editorRoute, dashboardRoute} from '../../../../routePaths';
import CustomIcon from '../../../../common/customIcon/CustomIcon';
import Link from '../../../../common/link/Link';
import inject from '../../../../hoc/injectHoc';
import {ILLUMINATIONDISPLAYS_SIGNUP_TYPE} from '../../../../../constants/subscriptionPlanConstants';
import {STATE_FULFILLED} from '../../../../../constants/asyncConstants';

import './linksSidebarList.scss';

/**
 * The project content ecosystem navigation component.
 */
class LinksSidebarList extends React.Component {
    /**
     * Loads user based on session
     */
    @action componentDidMount() {}

    /**
     * Renders the component.
     *
     * @returns {{}}
     */
    render() {
      const {apiUserGetMeStore} = this.props;
      const user = apiUserGetMeStore.getFulfilled();
      const companyManufacturerSignupType = lodash.get(user, 'company.manufacturerSignupType');

      const showSchedulerNavItem = apiUserGetMeStore.getState() === STATE_FULFILLED && companyManufacturerSignupType !== ILLUMINATIONDISPLAYS_SIGNUP_TYPE;

      return (
        <div className="header-sidebar-list sidebar-list">
          <div>
            <Link
              to={dashboardRoute}
              className="sidebar-list-item d-flex justify-content-between align-items-center"
            >
              <div>
                <CustomIcon
                  type="canvas"
                  className="mr-2"
                />
                Templates
              </div>
              <FontAwesomeIcon
                className="sidebar-list-item-append"
                icon={faCaretRight}
              />
            </Link>
            <Link
              to={editorRoute}
              params={{contentId: 'new'}}
              className="sidebar-list-item d-flex justify-content-between align-items-center"
            >
              <div>
                <CustomIcon
                  type="design-wand"
                  className="mr-3"
                />
                Canvas
              </div>
              <FontAwesomeIcon
                className="sidebar-list-item-append"
                icon={faCaretRight}
              />
            </Link>

            {showSchedulerNavItem && (
              <a
                href={mainConfig.navBar.scheduleSite}
                className="sidebar-list-item d-flex justify-content-between align-items-center"
              >
                <div>
                  <CustomIcon
                    type="schedule"
                    className="mr-3"
                  />
                  Scheduler
                </div>
                <FontAwesomeIcon
                  className="sidebar-list-item-append"
                  icon={faCaretRight}
                />
              </a>
            )}
          </div>
        </div>);
    }
}

LinksSidebarList.propTypes = {
  apiUserGetMeStore: MobxPropTypes.observableObject,
};

LinksSidebarList.wrappedComponent = {};
LinksSidebarList.wrappedComponent.propTypes = {
  apiUserGetMeStore: MobxPropTypes.observableObject.isRequired,
};

export default inject(LinksSidebarList)(
  observer(LinksSidebarList)
);
